import { useCheckoutPaymentStatus } from "../../hooks/api/v2/checkout/useCheckoutPaymentStatus";

export const useSellarCreditPaymentStatus = ({
  orderId,
}: {
  orderId: number;
}) => {
  const getCheckoutPaymentStatusQuery = useCheckoutPaymentStatus(
    {
      orderId,
    },
    {
      enabled: Boolean(orderId),
      refetchOnWindowFocus: false,
      refetchInterval: (response) => {
        if (
          response.state.data?.status !== "pending" ||
          !response.state.data.paymentCreatedAt
        ) {
          return false;
        }

        return 10_000; // Poll every 10 seconds
      },
    },
  );

  return {
    isProcessed: getCheckoutPaymentStatusQuery.data?.status === "succeeded",
    createdAt: getCheckoutPaymentStatusQuery.data?.paymentCreatedAt,
  };
};
